import script from "./FormRelativeTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormRelativeTime.vue?vue&type=script&lang=ts&setup=true"

import "./FormRelativeTime.vue?vue&type=style&index=0&id=7b28e59b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b28e59b"]])

export default __exports__